import { render, staticRenderFns } from "./ProjectMeasuresList.vue?vue&type=template&id=28b7256d&scoped=true"
import script from "./ProjectMeasuresList.vue?vue&type=script&lang=js"
export * from "./ProjectMeasuresList.vue?vue&type=script&lang=js"
import style0 from "./ProjectMeasuresList.vue?vue&type=style&index=0&id=28b7256d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7256d",
  null
  
)

export default component.exports